import React, { Fragment, useEffect, useState } from 'react';
export function Countdown() {
  const [seconds, setSeconds] = useState(85947);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(value - 1, 0)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: [string, number][] = [['HORAS', Math.floor(seconds / 3600)], ['MINUTOS', Math.floor(seconds % 3600 / 60)], ['SEGUNDOS', seconds % 60]];
  return <div className="flex justify-center gap-2 sm:gap-4" aria-label="La oferta termina pronto" data-id="element-296" data-mp="1oh6lms6ypinf">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-297" data-mp="1xh34ueal1pb3" data-mpi={index}>
          {index > 0 && <span className="pt-3 text-2xl font-black text-accent/40 sm:pt-4 sm:text-4xl" data-id="element-298" data-mp="1teg8q16vpi83">:</span>}
          <div className="min-w-[76px] rounded-xl border-2 border-primary bg-primary px-3 py-2.5 text-center shadow-sm sm:min-w-[104px] sm:px-5 sm:py-3" data-id="element-299" data-mp="38ux63p4qqs6r">
            <div className="text-3xl font-black leading-none text-accent sm:text-5xl" data-id="element-300" data-mp="34t2a905kx70d">
              {String(value).padStart(2, '0')}
            </div>
            <div className="mt-1 text-[10px] font-extrabold tracking-wider text-slate-300" data-id="element-301" data-mp="2h68jwb914wpz">
              {label}
            </div>
          </div>
        </Fragment>)}
    </div>;
}